import { BulletedList2Icon, GridViewMediumIcon } from "@fluentui/react-icons-mdl2";
import { CompatClient, Stomp } from "@stomp/stompjs";
import { Breadcrumb, Col, Row, Select, Space, Radio, Pagination, Empty, RadioChangeEvent } from "antd";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import SockJS from "sockjs-client";
import AuctionListView from "../../auction/online-auction/auction-list/components/AuctionListView";
import AuctionListViewOther from "../../auction/other-auction/auction-list-other/components/AuctionListViewOther";
import { AuctionResponse } from "../../auction/types";
import { SocketMessage } from "../../common/types/types";
import { useLazyGetProductCareListQuery } from "../redux/ProfileApi";
import { ProductCareSearch } from "../types";
import CareFilter from "./components/CareFilter";

const { Option } = Select;

const ProductCare = () => {
    const [isMine, setIsMine] = useState(false);
    const [trigger, response] = useLazyGetProductCareListQuery();
    const [startStatus, setStartStatus] = useState(0);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [submitValue, setSubmitValue] = useState<ProductCareSearch>();
    const [type, setType] = useState(0);
    const [productCareList, setProductCareList] = useState<AuctionResponse[]>([]);
    const stompClient = useRef<CompatClient>();
    const [listView, setListView] = useState(false);

    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const onError = () => {
            console.error("Websocket failed");
        }

        const onMessageReceived = (payload: any) => {
            const message: SocketMessage = JSON.parse(payload.body);
            if (message.type === "CHAT" && message.mapProductValue) {
                const id = Object.keys(message.mapProductValue)[0];
                let newProductCareList = [...productCareList];
                let itemIndex = productCareList.findIndex(item => item.productId === Number(id));
                if (itemIndex !== -1 && message.mapProductValue[id].bargainSuccess) {
                    newProductCareList[itemIndex] = {
                        ...newProductCareList[itemIndex],
                        bidderAcceptBid: {
                            valueOfBid: message.mapProductValue[id].valueOfBid
                        }
                    }
                }
                setProductCareList(newProductCareList);
            }
        }

        const onConnected = () => {
            if (stompClient.current) {
                stompClient.current.subscribe('/topic/group/bargain-product', onMessageReceived);
            }
        }

        if (productCareList.length) {
            if (!stompClient.current) {
                stompClient.current = Stomp.over(function () {
                    return new SockJS(process.env.REACT_APP_API_URL + "/ws")
                });

                const headers = {
                    'X-Authorization': 'token',
                }

                stompClient.current.connect(headers, onConnected, onError);
            } else if (!stompClient.current.active) {
                stompClient.current.activate();
            }
        }
    }, [productCareList])

    useEffect(() => {
        return () => {
            if (stompClient.current && stompClient.current.active) {
                stompClient.current.deactivate();
            }
        }
    }, [])

    useEffect(() => {
        trigger({
            page: 0,
            size: 10,
            type: 0,
        })
    }, [trigger])

    useEffect(() => {
        let newList: AuctionResponse[] = response.data?.content?.map(item => ({
            ...item,
            isCare: 1,
        })) || []
        setProductCareList(newList);
        scrollToStart();
    }, [response])

    const triggerSearch = (currentSubmitValue: ProductCareSearch) => {
        trigger({
            type,
            page: page - 1,
            size,
            ...(currentSubmitValue || submitValue),
        })
    }

    const scrollToStart = () => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const onPageChange = (currentPage: number) => {
        setPage(currentPage);
        triggerSearch({
            ...submitValue,
            page: currentPage - 1,
        })
    }

    const onTypeChange = (e: RadioChangeEvent) => {
        let newSubmitValue: ProductCareSearch = {
            ...submitValue,
            type: e.target.value,
            ...startStatus ? { startStatus } : {},
            page: 0,
            size,
        }
        triggerSearch(newSubmitValue)
        setType(e.target.value);
        setPage(1);
    }

    const onStartStatusChange = (e: RadioChangeEvent) => {
        setStartStatus(e.target.value);
        setPage(1);
        let newSubmitValue: ProductCareSearch = {
            ...submitValue,
            type,
            ...e.target.value ? { startStatus: e.target.value } : {},
            page: 0,
            size,
        }
        triggerSearch(newSubmitValue);
    }

    const onViewSelect = (e: RadioChangeEvent) => {
        setPage(1);
        setListView(e.target.value);
        triggerSearch({
            ...submitValue,
            page: 0,
        })
    }

    const onPageSizeChange = (currentSize: number) => {
        setSize(currentSize);
        setPage(1);
        triggerSearch({
            ...submitValue,
            size: currentSize,
        })
    }

    return (
        <div
            ref={divRef}
            style={{
                // padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 40,
                paddingBottom: 40,
            }}
        >
            <Space style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }} className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Tài sản quan tâm
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className="responsive-title">Danh sách tài sản quan tâm</div>
            </Space>
            <div className="responsive-padding-1440">
                <Row gutter={30}>
                    <Col span={6}>
                        <CareFilter setSubmitValue={setSubmitValue} triggerSearch={triggerSearch} startStatus={startStatus} setPage={setPage} submitValue={submitValue} />
                    </Col>
                    <Col span={18}>
                        <Row justify="space-between" align="middle" className="product-list-filter">
                            <Space size={20}>
                                <Radio.Group defaultValue={listView} className="filter-radio-group" onChange={(e) => onViewSelect(e)}>
                                    <Radio.Button value={true}>
                                        <BulletedList2Icon style={{ fontSize: 23 }} />
                                    </Radio.Button>
                                    <Radio.Button value={false}>
                                        <GridViewMediumIcon style={{ fontSize: 23 }} />
                                    </Radio.Button>
                                </Radio.Group>
                                <span>Tổng số <strong>{response.data?.totalElements || 0}</strong> kết quả</span>
                            </Space>
                            <Space size={20}>
                                <Radio.Group value={type} onChange={onTypeChange} className="custom-radio-group">
                                    <Radio.Button value={0}>Đấu giá trực tuyến</Radio.Button>
                                    <Radio.Button value={1}>Đấu giá khác</Radio.Button>
                                </Radio.Group>
                                {type === 0 ?
                                    <Radio.Group value={startStatus} onChange={onStartStatusChange} className="custom-radio-group">
                                        <Radio.Button value={0}>Tất cả</Radio.Button>
                                        <Radio.Button value={1}>Sắp diễn ra</Radio.Button>
                                        <Radio.Button value={2}>Đang diễn ra</Radio.Button>
                                        <Radio.Button value={4}>Đã kết thúc</Radio.Button>
                                    </Radio.Group>
                                    : <></>}
                            </Space>
                        </Row>

                        {response.data?.content.length ?
                            type === 0 ?
                                <AuctionListView
                                    type={listView ? "list" : "grid"}
                                    auctionList={productCareList}
                                    reloadPage={() => {
                                        trigger({
                                            ...submitValue,
                                            ...startStatus ? { startStatus } : {},
                                            page: page - 1,
                                            size,
                                            type,
                                        })
                                    }} /> :
                                <AuctionListViewOther
                                    type={listView ? "list" : "grid"}
                                    auctionList={productCareList}
                                    reloadPage={() => {
                                        trigger({
                                            ...submitValue,
                                            ...startStatus ? { startStatus } : {},
                                            page: page - 1,
                                            size,
                                            type,
                                        })
                                    }} />
                            : <Empty description="Không có dữ liệu" />}

                        <Row justify="end" align="middle" style={{ marginTop: 35, paddingRight: 37 }}>
                            <Select className="left-arrow-select" defaultValue={10} value={size} onChange={onPageSizeChange} dropdownStyle={{ borderRadius: 15 }}>
                                <Option value={10}>10</Option>
                                <Option value={20}>20</Option>
                                <Option value={50}>50</Option>
                                <Option value={100}>100</Option>
                            </Select>
                            <div style={{ marginRight: 20, marginLeft: 8, fontSize: 14 }}>Bản ghi</div>
                            <Pagination
                                defaultCurrent={1}
                                total={response.data?.totalElements || 0}
                                defaultPageSize={10}
                                pageSize={size}
                                className="custom-pagination"
                                current={page}
                                onChange={onPageChange}
                                showSizeChanger={false}
                            />
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default ProductCare